import { MutableRefObject, useEffect, useState } from 'react'

type UseFlipMaxHeightSyncParams = {
  isDesktopView: boolean
  isLoading: boolean
  summaryContainerRef: MutableRefObject<HTMLDivElement | null>
  arnContainerRef: MutableRefObject<HTMLDivElement | null>
}

export const useFlipMaxHeightSync = ({
  isDesktopView,
  isLoading,
  summaryContainerRef,
  arnContainerRef
}: UseFlipMaxHeightSyncParams): number => {
  const [maxHeight, setMaxHeight] = useState(0)

  useEffect(() => {
    const updateHeight = () => {
      if (
        isDesktopView &&
        summaryContainerRef.current &&
        arnContainerRef.current
      ) {
        const heightArn = arnContainerRef.current.offsetHeight
        const heightSummary = summaryContainerRef.current.offsetHeight
        setMaxHeight(Math.max(heightArn, heightSummary))
      }
    }

    updateHeight()
    globalThis.addEventListener('resize', updateHeight)

    return () => globalThis.removeEventListener('resize', updateHeight)
  }, [isDesktopView, isLoading, summaryContainerRef, arnContainerRef])

  return maxHeight
}

type UseFlipLayoutPaddingParams = {
  onLayoutPaddingMount: () => void | (() => void)
}

export const useFlipLayoutPadding = ({
  onLayoutPaddingMount
}: UseFlipLayoutPaddingParams): void => {
  useEffect(() => {
    return onLayoutPaddingMount()
  }, [onLayoutPaddingMount])
}

type UseFlipTosResetParams = {
  tosAccepted: boolean
  setTOSMustBeAccepted: (value: boolean) => void
}

export const useFlipTosReset = ({
  tosAccepted,
  setTOSMustBeAccepted
}: UseFlipTosResetParams): void => {
  useEffect(() => {
    if (tosAccepted) {
      setTOSMustBeAccepted(false)
    }
  }, [tosAccepted, setTOSMustBeAccepted])
}
